// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__wn_9m","nav__title":"Navigation_nav__title__2N6rR","nav__link":"Navigation_nav__link__2Ga5H"};